import { Button } from "@/components/ui/button"

// POSTs a CSRF-protected form to an OmniAuth request URL. OmniAuth 2 +
// omniauth-rails_csrf_protection require POST with the Rails authenticity token.
export function SsoButton({ label, path }: { label: string; path: string }) {
  const handleClick = () => {
    const token =
      document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
    const form = document.createElement("form")
    form.method = "post"
    form.action = path
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "authenticity_token"
    input.value = token
    form.appendChild(input)
    document.body.appendChild(form)
    form.submit()
  }

  return (
    <Button type="button" variant="outline" className="w-full" onClick={handleClick}>
      {label}
    </Button>
  )
}
